module.exports = __webpack_public_path__ + "img/scene-2.127b610.png";